import React, { useEffect } from "react";
import { Header } from "../components/portfolio/Header";
import { Hero } from "../components/portfolio/Hero";
import { About } from "../components/portfolio/About";
import { Projects } from "../components/portfolio/Projects";
import { Experience } from "../components/portfolio/Experience";
import { Expertise } from "../components/portfolio/Expertise";
import { BlogSection } from "../components/portfolio/BlogSection";
import { Contact } from "../components/portfolio/Contact";
import { Footer } from "../components/portfolio/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Natalia Halipchak — Corporate Finance & Accounting";
  }, []);

  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Projects />
        <Experience />
        <Expertise />
        <BlogSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
